export var WorkflowCheckErrorSubcodes;
(function (WorkflowCheckErrorSubcodes) {
    WorkflowCheckErrorSubcodes["InsufficientCredits"] = "ERROR_INSUFFICIENT_CREDITS";
})(WorkflowCheckErrorSubcodes || (WorkflowCheckErrorSubcodes = {}));
